import React from "react";
import RichTextPage from "../RichTextPage";

/** Üretim sayfası metni — Türkçe `Production`, çeviriler `Production_Lang`. */
export default function ProductionText() {
  return (
    <RichTextPage
      pageTitle="Üretim Metni"
      description="Üretim sayfasının metni bu ekrandan yönetilir."
      where="Metin, Üretim sayfasında başlığın hemen altında görünür; onun altındaki 6 adımlı üretim süreci kartları sabittir."
      links={[{ label: 'Üretim sayfası', path: '/uretim' }]}
      trTable="Production"
      trField="Production_Html"
      trBinary
      langTable="Production_Lang"
      langField="Production_Html"
    />
  );
}
